import '../scss/main.scss';

// Pełnoekranowy modal wyszukiwarki.
//
// Zastępuje wbudowany „slide search" Astry: klik w ikonę (.astra-search-icon)
// otwiera modal na całą stronę z wyśrodkowaną wyszukiwarką i przyciskiem ×
// w prawym górnym rogu. Zamykanie: ×, klik w tło, ESC.
//
// Klik w ikonę przechwytujemy delegacją na `document` w fazie CAPTURE i
// zatrzymujemy propagację — dzięki temu ubiegamy handler Astry (przypięty przez
// właściwość .onclick na ikonie), niezależnie od kolejności ładowania skryptów.
(function () {
	function initSearchModal() {
		var triggers = document.querySelectorAll('.astra-search-icon');
		var srcForm = document.querySelector('.ast-search-menu-icon .search-form');
		if (!triggers.length || !srcForm) {
			return;
		}

		var modal = document.createElement('div');
		modal.className = 'eq-search-modal';
		modal.setAttribute('role', 'dialog');
		modal.setAttribute('aria-modal', 'true');
		modal.setAttribute('aria-label', 'Wyszukiwarka');
		modal.hidden = true;

		var closeBtn = document.createElement('button');
		closeBtn.type = 'button';
		closeBtn.className = 'eq-search-close';
		closeBtn.setAttribute('aria-label', 'Zamknij wyszukiwarkę');
		closeBtn.innerHTML = '<span aria-hidden="true">&times;</span>';

		var inner = document.createElement('div');
		inner.className = 'eq-search-modal__inner';

		// Kopia formularza z nagłówka — zachowuje action/method, więc wyszukiwanie
		// działa natywnie. Klon nie ma handlerów JS Astry (nie kolidują z modalem).
		var form = srcForm.cloneNode(true);
		var field = form.querySelector('.search-field');
		var label = form.querySelector('label');
		if (field) {
			field.removeAttribute('tabindex');
			field.setAttribute('autocomplete', 'off');
			field.value = '';
			field.id = 'eq-search-field'; // unikaj duplikatu id z oryginałem
		}
		if (label) {
			label.setAttribute('for', 'eq-search-field');
		}
		inner.appendChild(form);

		modal.appendChild(closeBtn);
		modal.appendChild(inner);
		document.body.appendChild(modal);

		// Na mobile wyszukiwarka jest domyślnie schowana w panelu off-canvas.
		// Dodajemy widoczny przycisk lupy obok hamburgera (pokazywany tylko na
		// mobile przez CSS), który otwiera ten sam modal.
		var mobileToggle = document.querySelector('.main-header-menu-toggle');
		if (mobileToggle && mobileToggle.parentNode) {
			var mBtn = document.createElement('button');
			mBtn.type = 'button';
			mBtn.className = 'eq-mobile-search';
			mBtn.setAttribute('aria-label', 'Szukaj');
			mBtn.innerHTML = '<span class="ast-icon icon-search"><svg xmlns="http://www.w3.org/2000/svg" viewBox="-893 477 142 142" aria-hidden="true"><path d="M-787.4,568.7h-6.3l-2.4-2.4c7.9-8.7,12.6-20.5,12.6-33.1c0-28.4-22.9-51.3-51.3-51.3c-28.4,0-51.3,22.9-51.3,51.3c0,28.4,22.9,51.3,51.3,51.3c12.6,0,24.4-4.7,33.1-12.6l2.4,2.4v6.3l39.4,39.4l11.8-11.8L-787.4,568.7L-787.4,568.7z M-834.7,568.7c-19.7,0-35.5-15.8-35.5-35.5c0-19.7,15.8-35.5,35.5-35.5c19.7,0,35.5,15.8,35.5,35.5C-799.3,553-815,568.7-834.7,568.7L-834.7,568.7z"></path></svg></span>';
			mobileToggle.parentNode.insertBefore(mBtn, mobileToggle);
		}

		var lastFocused = null;

		function openModal(e) {
			if (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
			}
			lastFocused = document.activeElement;
			modal.hidden = false;
			document.body.classList.add('eq-search-open');
			window.setTimeout(function () {
				if (field) {
					field.focus();
				}
			}, 60);
		}

		function closeModal() {
			modal.hidden = true;
			document.body.classList.remove('eq-search-open');
			if (lastFocused && typeof lastFocused.focus === 'function') {
				lastFocused.focus();
			}
		}

		// Przechwyć klik w ikonę na poziomie document (capture) — ubiega Astrę.
		// Obsługuje ikonę Astry oraz dodany przez nas mobilny przycisk lupy.
		document.addEventListener('click', function (e) {
			var trigger = e.target.closest
				? e.target.closest('.astra-search-icon, .eq-mobile-search')
				: null;
			if (trigger) {
				openModal(e);
			}
		}, true);

		closeBtn.addEventListener('click', closeModal);

		// Klik w tło (samą warstwę, nie w formularz) zamyka.
		modal.addEventListener('click', function (e) {
			if (e.target === modal) {
				closeModal();
			}
		});

		document.addEventListener('keydown', function (e) {
			if ((e.key === 'Escape' || e.keyCode === 27) && !modal.hidden) {
				closeModal();
			}
		});
	}

	if (document.readyState !== 'loading') {
		initSearchModal();
	} else {
		document.addEventListener('DOMContentLoaded', initSearchModal);
	}
})();
